import { addEvent } from './includes/_events';
import { QuantitySelector } from "./includes/_quantity-selector.class";
import { QuantityUpdater } from "./includes/_quantity-updater";
const SUCCESS_MESSAGE_DISPLAY_TIMER = 3000;
const addToCartButtonStyle = Object.freeze({
  Default: 'mc-button--solid',
  Success: 'mc-button--bordered',
  Error: 'mc-button--bordered-danger'
});
const addToCartButtonImage = Object.freeze({
  Default: '#Product_Basket_Standard_24px',
  Success: '#Navigation_Notification_Available_32px',
  Error: '#Navigation_Control_Cross_32px'
});
async function addToCart(form, lightMode, eventTarget, self) {
  eventTarget.preventDefault();
  const parentEl = form.closest('.o-thumbnail');
  const listProducts = [];
  const productIdentifier = form.querySelector('input[name="reflm"]').value;
  const requestQuantity = form.querySelector('input[name="quantity"]') ? form.querySelector('input[name="quantity"]').value : 1;
  const offerId = form.querySelector('input[name="offerId"]').value;
  const contextCode = form.querySelector('input[name="contextCode"]').value;
  const atcButtonLocation = form.querySelector('input[name="atcButtonLocation"]').value;
  const useQuantitySelector = form.dataset.useQuantitySelector === 'true';
  listProducts.push({
    quantity: requestQuantity,
    reflm: productIdentifier,
    offerId,
    contextCode,
    atcButtonLocation,
    ...(lightMode && {
      lightMode,
      atcForm: form
    })
  });
  if (useQuantitySelector) {
    resetQuantitySelectorVisibility();
    const wrapperEl = parentEl.querySelector(".js-quantity-selector-wrapper");
    if (wrapperEl) {
      displayQuantitySelector(parentEl, true);
      const designation = form.querySelector('input[name="designation"]').value;
      const params = new URLSearchParams({
        'productId': productIdentifier,
        'offerId': offerId,
        'atcButtonLocation': atcButtonLocation,
        'storeId': contextCode,
        'designation': btoa(encodeURIComponent(designation))
      });
      const response = await fetch('/application/product-quantity-selector?' + params.toString());
      if (!response.ok) {
        console.error("Unable to fetch quantity selector for product", productIdentifier);
        displayQuantitySelector(parentEl, false);
        self.cartUpdate({
          listProducts
        });
      } else {
        wrapperEl.innerHTML = await response.text();
        const quantitySelectorForm = wrapperEl.querySelector('.js-quantity-selector-form');
        if (quantitySelectorForm) {
          new QuantitySelector(quantitySelectorForm);
          new QuantityUpdater(quantitySelectorForm, wrapperEl);
        }
      }
    }
  } else {
    self.cartUpdate({
      listProducts
    });
  }
}
function displayQuantitySelector(parentEl) {
  let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!parentEl) {
    return;
  }
  const isMobile = window.matchMedia('(min-width: 680px)');
  const overlayEl = parentEl.querySelector('.js-quantity-overlay');
  const wrapperEl = parentEl.querySelector('.js-quantity-selector-wrapper');
  if (!isMobile.matches) {
    document.documentElement.classList.toggle('is-scroll-locked', display);
  }
  overlayEl.classList.toggle('is-visible', display);
  wrapperEl.classList.toggle('kl-hidden', !display);
}
function resetQuantitySelectorVisibility() {
  const thumbnailsEl = document.querySelectorAll(".o-thumbnail");
  for (const el of thumbnailsEl) {
    displayQuantitySelector(el, false);
  }
}
function handleSuccessMessage(form) {
  const svgElement = form.querySelector('.js-thumbnail-add-to-cart-light-form svg use');
  const buttonAddToCart = form.querySelector('.js-thumbnail-add-to-cart-light-form button');
  const successMessage = form.querySelector('.product-thumbnails-add-to-cart-msg__success');
  displaySuccessMessage(successMessage, svgElement, buttonAddToCart);
  setTimeout(() => hideSuccessMessage(successMessage, svgElement, buttonAddToCart), SUCCESS_MESSAGE_DISPLAY_TIMER);
}
function displaySuccessMessage(successMessage, svgElement, buttonAddToCart) {
  successMessage.classList.remove('kl-hidden');
  if (svgElement) {
    svgElement.setAttribute('href', addToCartButtonImage.Success);
    buttonAddToCart.classList.replace(addToCartButtonStyle.Default, addToCartButtonStyle.Success);
  }
}
function hideSuccessMessage(successMessage, svgElement, buttonAddToCart) {
  if (svgElement) {
    svgElement.setAttribute('href', addToCartButtonImage.Default);
    buttonAddToCart.classList.replace(addToCartButtonStyle.Success, addToCartButtonStyle.Default);
  }
}
function handleErrorMessage(form) {
  const errorMessage = document.querySelector('.product-thumbnails-atc-notification-fail');
  const buttonCloseNotification = document.querySelector('.product-thumbnails-atc-fail__close');
  const formAddToCart = form.querySelector('.js-cart-add');
  errorMessage.classList.remove('kl-hidden');
  formAddToCart.classList.add('kl-hidden');
  buttonCloseNotification.addEventListener('click', () => {
    errorMessage.classList.add('kl-hidden');
  });
}
class ProductThumbnail extends lm.Composant {
  constructor(id) {
    super(id);
    window.THUMBNAIL = window.THUMBNAIL || {};
    window.THUMBNAIL.instances = window.THUMBNAIL.instances || {};
    if (!window.THUMBNAIL.instances.ProductThumbnail) {
      window.THUMBNAIL.instances.ProductThumbnail = this;
      this._init();
    }
    return window.THUMBNAIL.instances.ProductThumbnail;
  }
  _init() {
    document.addEventListener('cartSuccess', event => {
      if (event?.detail?.product?.atcForm) {
        handleSuccessMessage(event.detail.product.atcForm);
      }
    });
    document.addEventListener('cartError', event => {
      if (event?.detail?.product?.atcForm) {
        handleErrorMessage(event.detail.product.atcForm);
      }
    });
    addEvent(document, 'submit', e => addToCart(e.matchingTarget, false, e, this), '.js-thumbnail-add-to-cart-form', this);
    addEvent(document, 'submit', e => addToCart(e.matchingTarget, true, e, this), '.js-thumbnail-add-to-cart-light-form', this);
    addEvent(document, 'click', e => displayQuantitySelector(e.matchingTarget.closest('.o-thumbnail'), false), '.js-quantity-overlay', this);
    addEvent(document, 'click', () => window.dispatchEvent(new CustomEvent('openStoreContextLayerInSearchMode')), '.js-th-display-availabilities', this);
    addEvent(document, 'click', e => document.dispatchEvent(new CustomEvent('arm-popin-dsa-open', {
      detail: e.matchingTarget.getAttribute('data-io')
    })), '.arm-thumbnail-open-modal', this);
  }
}
lm.DOMReady(function () {
  new ProductThumbnail('product-thumbnail');
});
export default ProductThumbnail;